export default "__VITE_ASSET__9c28b2e5__"